export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/descending.js
// module id = 3787
// module chunks = 0